export default __webpack_public_path__ + "static/media/change_language.92509ac8.svg";